import { ActiveMenusGeneralInfo, ActiveMenusResponse, MenuId } from './types'

/**
 * Convert the data structure as received from wire into the shape the WebClient consumes.
 */
export function transformResponse(rawResponse?: ActiveMenusResponse): ActiveMenusGeneralInfo {
  return (rawResponse?.data || []).map((menuRecord) => ({
    menuId: menuRecord.id as MenuId,
    coreMenuId: menuRecord.attributes.core_menu_id,
    corePeriodId: menuRecord.attributes.period.core_period_id,
    startsAt: menuRecord.attributes.starts_at,
    endsAt: menuRecord.attributes.ends_at,
  }))
}
